'use strict';

angular.module('navigation')
  .controller('NavbarCtrl', ['$scope', '$window', 'navigationService', 'magAssistConfigService', function ($scope, $window, navigationService, magAssistConfigService) {
    $scope.navigation = navigationService;
    $scope.magAssistConfig = magAssistConfigService;
    $scope.openCustomerList = function ($event) {
      $event.preventDefault();
      magAssistConfigService.init().then(function () {
        $window.location.href = magAssistConfigService.getCustomerListUrl();
      });
    };
  }]);
